import React, { PureComponent } from 'react';
import { message, Modal, Button } from 'antd';
import * as XLSX from 'xlsx';
import { services } from '@comall-backend-builder/core';
import './index.less';
const api = services.api;
interface UploadButtonState {
    showUploadModal: boolean;
    toggleUploadModal: any;
    type: string;
}

export class ShowProductsUploadButtonSpu extends PureComponent<UploadButtonState> {
    state = {
        confirmLoading: false,
        modalTitle: '批量导入商品',
        apiRoot: ENV.API_ROOT,
        skuArr: [],
    };
    // modal关闭
    handleCancel = () => {
        this.props.toggleUploadModal();
    };
    // 导入excel后将excel中的sku读取出来，并输出为json形式
    onImportExcel = (file) => {
        // 获取上传的文件对象
        const { files } = file.target;
        // 通过FileReader对象读取文件
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
            try {
                const { result } = event.target;
                // 以二进制流方式读取得到整份excel表格对象
                const workbook = XLSX.read(result, { type: 'binary' });
                // 存储获取到的数据
                let data = [];
                // 遍历每张工作表进行读取（这里默认只读取第一张表）
                for (const sheet in workbook.Sheets) {
                    // esline-disable-next-line
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        // 利用 sheet_to_json 方法将 excel 转成 json 数据
                        data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        break; // 如果只取第一张表，就取消注释这行
                    }
                }
                // 最终获取到并且格式化后的 json 数据,进行具体业务校验
                this.checkArr(data);
                // console.log('数据呢？',data);
            } catch (e) {
                // 这里可以抛出文件类型错误不正确的相关提示
                message.error('文件类型不正确！', 3);
            }
        };
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(files[0]);
    };
    // 格式化后的 json 数据,具体业务校验
    checkArr = (data) => {
        let arr = [];
        if (data.length) {
            data.forEach((item) => {
                if (item['SPU编号']) {
                    arr.push(item['SPU编号']);
                } else if (item['spu编码']) {
                    arr.push(item['spu编码']);
                }
            });
        } else {
            message.error('导入的数据不能为空！', 3);
            return;
        }
        console.log('skuarr是啥', arr);
        if (arr.length == 0) {
            message.error('导入的表格数据格式有误！', 3);
            return;
        } else {
            message.success("文件解析成功！点击'确定'导入", 2);
            this.setState({
                skuArr: arr,
            });
        }
    };
    // modal确认时调用接口，将skus传给后台，后台返回对应sku所有信息
    handleOk = async () => {
        const { skuArr } = this.state;
        this.setState({
            confirmLoading: true,
        });

        let res = await this.getskuListBySkus(skuArr);
        this.setState({
            confirmLoading: false,
        });
        this.props.toggleUploadModal(res);
    };
    getskuListBySkus = async (skus) => {
        let res: any = await api.get(
            { page: 1, per_page: 1000, spus: skus },
            { apiPath: '/products/search/find_spu', apiRoot: ENV.API_ROOT }
        );
        return res.result;
    };
    render() {
        const { showUploadModal, type } = this.props;
        const { confirmLoading, modalTitle, apiRoot } = this.state;
        return (
            <Modal
                destroyOnClose={true}
                maskClosable={false}
                centered
                title={modalTitle}
                visible={showUploadModal}
                onOk={this.handleOk}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                <Button type="primary" className="upload-wrap">
                    <input
                        className="file-uploader"
                        type="file"
                        accept=".xlsx"
                        onChange={this.onImportExcel}
                    />
                    <span className="upload-text">批量导入SPU</span>
                </Button>
                <p className="upload-tip">支持 .xlsx 格式的文件</p>
                {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
                {/* <Button type="default">下载模板</Button> */}
            </Modal>
        );
    }
}
